var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Tooltip, tooltipClasses } from '@mui/material';
var PrimaryToolTip = function (props) {
    return (React.createElement(Tooltip, __assign({ arrow: true, placement: "top", PopperProps: {
            disablePortal: true,
            sx: function (theme) {
                var _a;
                return (_a = {},
                    _a["& .".concat(tooltipClasses.tooltip)] = {
                        backgroundColor: theme.palette.primary['900'],
                        padding: '12px 16px 12px 16px',
                        borderRadius: '8px'
                    },
                    _a["& .".concat(tooltipClasses.arrow)] = {
                        color: theme.palette.primary['900']
                    },
                    _a);
            }
        }, disableFocusListener: true, disableHoverListener: true, disableTouchListener: true }, props), props.children));
};
export default PrimaryToolTip;
//# sourceMappingURL=PrimaryTooltip.js.map